import React, { useEffect, useState, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Loader from "react-js-loader";
import { Navigate, Outlet } from 'react-router-dom';
import { getEndpointUrl } from '../Utils/Common';

const PrivateRoute = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [auth, setAuth] = useState(false);

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const fetchData = useCallback(async () => {
        let formData = new FormData();
        formData.append('username', userLogin.username);

        fetch(getEndpointUrl() + `/users/is_login`, {
            method: 'POST',
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setAuth(true);
                localStorage.setItem('credentials', JSON.stringify(json.tokenAccess));
            } else {
                setAuth(false);
            }

            setIsLoading(false);
        }).catch(error => {
            setAuth(false);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [accesToken, fetchData]);

    return isLoading ?
        <Container>
            <Row>
                <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                    <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                </Col>
            </Row>
        </Container>
        : auth ? <Outlet /> : <Navigate to="/login" />; 
}

export default PrivateRoute;